import { ActionTypes } from '../types/actionTypes';

export interface ISidebar {
  collapse: boolean;
}

const initialState = {
  collapse: false,
} as ISidebar;

export interface ISetSizeSidebar {
  type: typeof ActionTypes.SET_SIZE_SIDEBAR;
  payload: boolean;
}

type TSidebarActionTypes = ISetSizeSidebar;

export default function sidebar(state = initialState, action: TSidebarActionTypes) {
  switch (action.type) {
    case ActionTypes.SET_SIZE_SIDEBAR:
      return { ...state, collapse: action.payload };
    default:
      return state;
  }
}
